import React, { useEffect, useRef, useState } from "react";
import { Button } from "@material-ui/core";
import { TextFieldFormsy } from "@fuse";
import Formsy from "formsy-react";
import * as authActions from "app/auth/store/actions";
import { useDispatch, useSelector } from "react-redux";

function LoginBox(props) {
	const dispatch = useDispatch();
	const login = useSelector(({ auth }) => auth.login);

	const [isFormValid, setIsFormValid] = useState(false);
	const formRef = useRef(null);

	useEffect(() => {
		console.log("login.error: ", login.error);
		if (login.error && (login.error.email || login.error.password)) {
			formRef.current.updateInputsWithError({
				...login.error,
			});
			disableButton();
		}
	}, [login.error]);

	function disableButton() {
		setIsFormValid(false);
	}

	function enableButton() {
		setIsFormValid(true);
	}

	function handleSubmit(model) {
		// dispatch(authActions.submitLogin(model));
		dispatch(authActions.submitLoginWithFireBase(model));
	}

	return (
		<div className="w-full">
			<Formsy
				onValidSubmit={handleSubmit}
				onValid={enableButton}
				onInvalid={disableButton}
				ref={formRef}
				className="flex flex-col justify-center w-full"
			>
				<TextFieldFormsy
					className="mb-16"
					type="text"
					name="email"
					label="이메일"
					validations={{
						minLength: 4,
						isEmail: true,
					}}
					validationErrors={{
						minLength: "최소 4자 이상입니다.",
						isEmail: "올바른 이메일 형식이 아닙니다.",
					}}
					// InputProps={{
					// 	endAdornment: (
					// 		<InputAdornment position="end">
					// 			<Icon className="text-20" color="action">
					// 				email
					// 			</Icon>
					// 		</InputAdornment>
					// 	),
					// }}
					variant="outlined"
					required
				/>

				<TextFieldFormsy
					className="mb-16"
					type="password"
					name="password"
					label="비밀번호"
					validations={{
						minLength: 8,
					}}
					validationErrors={{
						minLength: "최소 8자 이상입니다.",
					}}
					// InputProps={{
					// 	endAdornment: (
					// 		<InputAdornment position="end">
					// 			<Icon className="text-20" color="action">
					// 				vpn_key
					// 			</Icon>
					// 		</InputAdornment>
					// 	),
					// }}
					variant="outlined"
					required
				/>

				<Button
					type="submit"
					variant="contained"
					color="primary"
					className="w-full mx-auto mt-16 normal-case"
					aria-label="LOG IN"
					disabled={!isFormValid}
					value="legacy"
				>
					로그인
				</Button>
			</Formsy>
		</div>
	);
}

export default LoginBox;
